import SubscriptionProduct from "@/models/general/settings/RoadcubeMarket/SubscriptionProduct";

export default {
    namespaced: true,

    state: () => ({
        product: new SubscriptionProduct(),
        products: [],
        productsPagination: {},
        productTypes: [],
        credits: [],
        creditOptions: []
    }),

    mutations: {
        setProducts(state, payload) {
            state.products = payload || [];
        },

        setProduct(state, payload) {
            state.product = new SubscriptionProduct(payload);
        },

        setProductsPagination(state, payload) {
            state.productsPagination = payload || {};
        },

        setProductTypes(state, payload) {
            state.productTypes = payload || [];
        },

        setCredits(state, payload) {
            state.credits = payload || [];
        },
        setCreditOptions(state, payload) {
            state.creditOptions = payload || [];
        }
    },

    actions: {
        async getProducts({ commit }) {
            try {
                commit("setLoading", true, { root: true });
                const { data } = await SubscriptionProduct.getProducts();
                commit("setProducts", data.data.subscription_products);
                commit("setProductsPagination", data.data.pagination);
                commit("setLoading", false, { root: true });
            } catch (ex) {
                commit("setLoading", false, { root: true });
                console.error(ex?.response?.data);
            }
        },

        async getProductTypes({ commit }) {
            try {
                commit("setLoading", true, { root: true });
                const { data } = await SubscriptionProduct.getProductsTypes();
                commit("setProductTypes", data.data);
                commit("setLoading", false, { root: true });
            } catch (ex) {
                commit("setLoading", false, { root: true });
                console.error(ex?.response?.data);
            }
        },

        async create({ commit, dispatch }, body) {
            try {
                commit("setLoading", true, { root: true });
                const { data } = await SubscriptionProduct.createProduct(body);
                commit("setLoading", false, { root: true });
                return data;
            } catch (ex) {
                commit("setLoading", false, { root: true });
                console.error(ex?.response?.data);
            }
        },

        async update({ commit },  product ) {
            try {
                commit("setLoading", true, { root: true });
                const { data } = await SubscriptionProduct.updateProduct(
                    product.subscription_product_id,
                    product
                );
                commit("setLoading", false, { root: true });
                return data;
            } catch (ex) {
                commit("setLoading", false, { root: true });
                console.error(ex?.response?.data || ex);
            }
        },

        async uploadImage({ commit, rootState }, { product, image }) {
            try {
                const fd = new FormData();
                fd.append("image", image);

                const { data } = await SubscriptionProduct.uploadImage(
                    product.subscription_product_id,
                    fd
                );

                product.image = data.data.image;
                commit("setLoading", false, { root: true });
                commit("setDialog", false, { root: true });
                return product;
            } catch (ex) {
                commit("setLoading", false, { root: true });
                console.log(ex);
                commit(
                    "setErrorMessage",
                    ex?.response?.data?.message || ex?.message,
                    {
                        root: true
                    }
                );
                setTimeout(
                    () => commit("setErrorMessage", "", { root: true }),
                    5000
                );
            }
        },
        async getCredits({ commit }) {
            try {
                commit("setLoading", true, { root: true });
                const { data } = await SubscriptionProduct.getCredits();
                commit("setCredits", data.data);
                commit("setLoading", false, { root: true });
            } catch (ex) {
                commit("setLoading", false, { root: true });
                console.error(ex?.response?.data);
            }
        },
        async getCreditOptions({ commit }) {
            try {
                commit("setLoading", true, { root: true });
                const { data } = await SubscriptionProduct.getCreditOptions();
                commit("setCreditOptions", data.data);
                commit("setLoading", false, { root: true });
            } catch (ex) {
                commit("setLoading", false, { root: true });
                console.error(ex?.response?.data);
            }
        }
    }
};
